
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState } from 'vuex'

import Guide from 'components/module/guide'
import Webupgrade from 'components/sysinfo/webupgrade'
import Postcode from 'components/address/postcode'
import Guest from 'components/tour/guest'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { defineComponent } from 'vue'
import Turnstile from 'cfturnstile-vue2'

import Vue from 'vue'
export default {
directives: {
TransferDom
},
components: {
Loading,
ViewBox,
Guide,
Webupgrade,
Postcode,
Turnstile,
Guest
},
provide() {
return {
reload: this.reload
}
},
data() {
return {
firstLoad: true,
isRouterAlive: true,
openScreen: '',
status: true,
isIphonex: false,
fringeDirection: '',
is_leader:false,
is_guest:false,
turnstile_conf:''
}
},
computed: {
...mapState(['isLoading', 'direction']),
},
mounted() {
let that = this
let ref = that.getQueryVariable('s_ref')
let leader_id = that._func.strStorage('leader_id')
let signLink = that.req_url
that._func.copyright()
that.$iphonex.$on('init', (v) => {
/*that.isIphonex = that._func.isPhonex()
if (that.isIphonex) {
document.querySelector('#vux_view_box_html').classList.add('x-html');
}*/
})
that.$iphonex.$on('rotate', (v) => {
that.fringeDirection = v
})

that._ajax.fetch('confjs', { cusPlatform: that.platform, ref: ref, url: signLink }, that, false).then(res => {
if (res) {
if(!that._func._isMobile()){
window.location.href = res.data.pc_http+that.$route.path
}
that._util.setLang(res.data.lang, res.lang)
that.$store.commit('G_USERINFO', res.userInfo)
that.$store.commit('G_DATA', res.data)

that.is_leader = res.data.is_leader
that.is_guest = res.GUEST_BOOKING
that.status = res.data.status
if (!that._func.empty(res.guide)) {
that.openScreen = res.guide
}
that.token_conf.set('tokenlang',res.data.lang_id)
that.token_conf.set('tokencurrency',res.data.currency_id)
localStorage.setItem('tokenchannel',res.data.sys_info.channel)
if (res.data.sys_info.third_js) {
that._func.script_text(res.data.sys_info.third_js)
}
if (res.data.sys_info.third_js_header) {
that._func.script_include_text(res.data.sys_info.third_js_header)
}
/*if (res.data.city && !that._func.empty(res.data.city.list)) {
that._func.script_iframe(res.data.city.list,res.data.main_url)
}*/
if (res.ref && !leader_id) {
that._func.strStorage('leader_id', res.ref)
}
if (!that._func.empty(res.wx_conf)) {
let f = [
'checkJsApi',
'updateTimelineShareData',
'updateAppMessageShareData',
'showMenuItems',
'openLocation',
'getLocation',
'onMenuShareTimeline',
'onMenuShareAppMessage'
]
that._func.setConf(that, res.wx_conf, f)
}

if (res.data.g_recaptcha) {
if(res.data.captcha_type && res.data.captcha_type == 'turnstile'){
that.turnstile_conf = res.data.g_recaptcha
}else{
Vue.use(VueReCaptcha, {
siteKey: res.data.g_recaptcha,
loaderOptions: {
useRecaptchaNet: true
}
})
}

}
that._func.setHtml(res.data.sys_info)
that.$store.commit('G_MENU', { footer: res.footer })
}
that.$store.commit('G_INITIALIZE', 1)
})
},
methods: {
getQueryVariable(variable) {
let that = this
let ref = that._func.strStorage('s_ref')
if (ref) {
return ref
}
let query = window.location.search.substring(1)
let vars = query.split('&')
for (let i = 0; i < vars.length; i++) {
let pair = vars[i].split('=')
if (pair[0] == variable) {
that._func.strStorage('s_ref', pair[1])
return pair[1]
}
}
return false
},
reload() {
this.isRouterAlive = false
this.$nextTick(() => {
this.isRouterAlive = true
})
},
turnstile_verify(token) {
console.log(99,token)
}
}
}
